import { useState } from "react";

// Accepts onManualConnect callback and disabled state
const RconManualConnect = ({ onManualConnect, disabled }) => {
    const [manualPort, setManualPort] = useState('');
    const [manualPassword, setManualPassword] = useState('');

    const handleConnect = () => {
        if (!manualPort || isNaN(parseInt(manualPort))) return; // Basic validation
        onManualConnect(parseInt(manualPort), manualPassword);
    };

    return (
        <div className="mb-6 bg-dark-500 rounded-2xl p-5 border border-dark-400 hover:border-accent-green/30 transition-colors relative overflow-hidden transform-gpu hover:scale-[1.01]">
             {/* Optional background effect */}
             <div className="absolute -left-10 -top-10 w-32 h-32 bg-accent-green opacity-5 rounded-full blur-xl"></div>

            <h4 className="font-bold text-md mb-3 flex items-center text-gray-200">
                <i className="fas fa-plug mr-2 text-accent-green"></i>
                Connect Directly (If RCON Known)
            </h4>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                <div className="sm:col-span-1">
                    <label htmlFor="manual-port" className="block text-xs text-gray-400 mb-1">RCON Port</label>
                    <input
                        id="manual-port"
                        type="number"
                        placeholder="e.g., 25575"
                        value={manualPort}
                        onChange={(e) => setManualPort(e.target.value)}
                        className="w-full bg-dark-600 rounded-lg py-2 px-3 text-sm border border-dark-400 focus:outline-none focus:ring-1 focus:ring-accent-green/50 hover:border-dark-300 transition disabled:opacity-50"
                        disabled={disabled}
                        min="1" max="65535"
                    />
                </div>
                <div className="sm:col-span-1">
                    <label htmlFor="manual-password" className="block text-xs text-gray-400 mb-1">RCON Password</label>
                    <input
                        id="manual-password"
                        type="password"
                        placeholder="Enter password"
                        value={manualPassword}
                        onChange={(e) => setManualPassword(e.target.value)}
                        className="w-full bg-dark-600 rounded-lg py-2 px-3 text-sm border border-dark-400 focus:outline-none focus:ring-1 focus:ring-accent-green/50 hover:border-dark-300 transition disabled:opacity-50"
                        disabled={disabled}
                    />
                </div>
                 <div className="sm:col-span-1 flex items-end">
                    <button
                        onClick={handleConnect}
                        disabled={disabled || !manualPort || isNaN(parseInt(manualPort)) || !manualPassword}
                        className="w-full py-2 bg-gradient-to-r from-accent-green to-accent-blue text-white rounded-lg text-sm font-medium transition hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        <i className="fas fa-link mr-1"></i> Connect
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RconManualConnect;